<template>
  <div class="cross-project">
    <div class="projectFolder-top-nav">
      <el-tabs v-model="ruleForm.approval_status" @tab-click="handleClick">
        <el-tab-pane label="已通过" name="2">
          <div slot="label" class="tabs-item">
            <span>已通过</span>
            <!-- <span>{{countList.active}}</span> -->
            <span class="task-badge" style="margin-left: 6px;" v-show="getCountNumber(2).msgcount > 0"></span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="审核中" name="1">
          <div slot="label" class="tabs-item">
            <span>审核中</span>
            <!-- <span class="num" v-if="countNumber[1] > 0"><a>{{countNumber[1] > 99 ? '99+' : countNumber[1]}}</a></span> -->
            <span class="task-badge" style="margin-left: 6px;" v-show="getCountNumber(1).msgcount > 0 || getCountNumber(1).number > 0"></span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="未通过" name="3">
          <div slot="label" class="tabs-item">
            <span>未通过</span>
            <!-- <span><a>{{countList.archived}}</a></span> -->
            <span class="task-badge" style="margin-left: 6px;" v-show="getCountNumber(3).msgcount > 0"></span>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="btns">
        <wf-button plain @click="$router.push('/crossProjectSetting')" style="margin-right: 24px;" icon="icon iconfont iconicon_project_management" v-if="permission && permission.management_index_permission">项目管理</wf-button>
        <wf-button class="add-project-btn" icon="icon iconfont iconicon_enlarge" v-if="permission && permission.create_cross_project_permission" @click="add">新建项目</wf-button>
      </div>
    </div>
    <div class="content-card" v-if="ruleForm.approval_status === '2'" v-loading="loading">
      <div class="content-card-in">
        <!-- class="card-cell activeCardHover" -->
        <div class="card-cell" v-for="item in dataset" :key="item.id"  @click="handleCheckDetail(item.id)">
          <ColorCard :dataset="item" @change="colorChange" :disabled="!item.permissions" :defaultText="item.project_name">
            <template>
              <div class="btn-box">
                <toolTip style="width: 70%;" class="title" :title="item.project_name">
                  <span>{{item.project_name}}</span>
                </toolTip>
                <span class="num"><i class="icon iconfont iconicon_action_item"></i>{{item.number_of_projects}}</span>
              </div>
            </template>
          </ColorCard>
          <div class="task-msgcount-super" v-show="item.msgcount > 0">{{item.msgcount > 100 ? '99+' : item.msgcount}}</div>
        </div>
      </div>
      <Nothing v-if="dataset.length === 0"></Nothing>
    </div>
    <div class="content" v-else>
      <commonTable :height="'100%'" tableHead="crossProject" :apiUrl="{url:'home',methods:'getCrossProjects'}" ref="commonTable" :params="ruleForm" :selection="false" :tipShow="false" :verifyRemark="true" @selectSingle="selectSingle" :rowClassName="rowClassName" :popover="false" :verifyWidth="100">
        <!-- <template slot="project_start_time" slot-scope="dataset">
          <span>{{dataset.data.project_start_time ? dataset.data.project_start_time.split(' ')[0].replace(/-/g,'/') + ' ~ ' + dataset.data.project_end_time.split(' ')[0].replace(/-/g,'/') : '-'}}</span>
        </template> -->
        <template slot="joined_departments" slot-scope="row">
          <toolTip :title="row.data.joined_departments ? row.data.joined_departments.map(res => res.name).join('、') : '-'">
            {{row.data.joined_departments ? row.data.joined_departments.map(res => res.name).join('、') : '-'}}
          </toolTip>
        </template>
        <template slot="important_members" slot-scope="row">
          <toolTip :title="row.data.important_members ? row.data.important_members.map(res => res.realname).join('、') : '-'">
            {{row.data.important_members ? row.data.important_members.map(res => res.realname).join('、') : '-'}}
          </toolTip>
        </template>
        <template slot="verifyRemark" slot-scope="dataset">
          <span class="add-btn" @click="openDetail(dataset.data)">查看详情</span>
        </template>
      </commonTable>
    </div>
    <Detail v-model="detailDialogVisible" :id="checkId" @success="init"></Detail>
  </div>
</template>
<script>
import Detail from './detail'
import api from '@/services/api/home/home'
import apiProject from '@/services/api/project/project'
import Nothing from '@/components/nothing'
import { mapState, mapMutations } from 'vuex'
import ColorCard from '@/components/colorControl/card'
export default {
  components: {
    Detail,
    Nothing,
    ColorCard
  },
  data() {
    return {
      ruleForm: {
        approval_status: '2',
      },
      countList: {},
      dataset: [],
      projectDetailId: null,
      showProjectDetail: false,
      detailDialogVisible: false,
      checkId: '',
      loading: false
    }
  },
  computed: {
    ...mapState('home/home', {
      countNumber: state => state.countNumber,
      permission: state => state.crossPermission
    }),
    ...mapState('cross/cross', {
      approval_status: state => state.approval_status
    })
  },
  created() {

  },
  mounted() {
    this.createdInit()
  },
  methods: {
    ...mapMutations('cross/cross',['SET_ACTIVE']),
    async init(fl) {
      this.SET_ACTIVE(String(fl))
      this.createdInit()
    },
    createdInit() {
      if(this.approval_status) {
        this.ruleForm.approval_status = this.approval_status
        if(this.ruleForm.approval_status === '2') {
          this.getStatusCard()
        } else {
          this.$nextTick(() => {
            this.$refs.commonTable ? this.$refs.commonTable.getTableList() : ''
          })
        }
      } else {
        this.SET_ACTIVE(this.ruleForm.approval_status)
        return
      }
    },
    handleClick() {
      this.init(this.ruleForm.approval_status)
    },
    add() {
      this.$router.push('/addCrossProject')
    },
    openDetail(val) {
      this.detailDialogVisible = true
      this.checkId = val.id
    },
    //点击查看跨团队项目详情
    handleCheckDetail(id) {
      this.$router.push('./crossProjectDetail?id=' + id)
    },
    async getStatusCard() {
      this.loading = true
      try {
        let result = await api.getCrossProjects({per_page: 999, page: 1,...this.ruleForm})
        this.dataset = result.data
      } catch (error) {
      }
      this.loading = false
    },
    selectSingle(row) {
      this.openDetail(row)
    },
    rowClassName () {
      return 'row-current'
    },
    getCountNumber(approval_status) {
      return (this.countNumber.find(res => res.approval_status === approval_status)) || {}
    },
    async colorChange(item) {
      console.log(item)
      let {id, background_color, background_text} = item
      this.dataset.find(res => {
        if(res.id === item.id) {
          res.background_color = background_color
          res.background_text= background_text
          return true
        }
      })
      let params = {
        id,
        background_color,
        background_text
      }
      await apiProject.updateCrossProjectsBackground(params)
    }
  }
}
</script>
<style lang="scss" scoped>
.cross-project{
  display: flex;
  flex-direction: column;
  height: 100%;
  .add-btn {
    cursor: pointer;
    color: $color-active;
    margin: 0 17px;
  }
  /deep/ {
    .row-current{
      cursor: pointer;
    }
    .common-table{
      display: flex;
      flex-direction: column;
    }
    .multipleTable-box {
      height: 0;
      flex: 1;
    }
  }
  .content{
    height: 0;
    flex: 1;
    padding: 0 40px;
  }
  .content-card {
    flex: 1;
    height: 0;
    overflow-x: hidden;
    overflow-x: overlay;
    position: relative;
  }
  .content-card-in {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 24px;
    align-content:flex-start;
    padding-top: 24px;
    padding-left: 40px;
    .btn-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      font-size: 14px;
      font-weight: 400;
      .num {
        color: rgba(32, 32, 32, 0.6);
        font-size: 14px;
        i {
          font-size: 14px;
          margin-right: 9px;
        }
      }
    }
    .card-cell {
      width: 280px;
      position: relative;
    }
  }
  .btns {
    display: flex;
    align-items: center;
    /deep/ .iconicon_project_management {
      font-size: 14px;
    }
  }
}
</style>
